import React from "react";
import CustomHeroCard from "../MsUiComponents/CustomHeroCard";
import FileUploadCard from "./FileUploadExtension/FileUploadCard";
import CustomMessage from "../MsUiComponents/CustomMessage";
import CustomVideoCard from "../MsUiComponents/CustomVideoCard";

export const AttachmentMiddleware =
  (
    api,
    botSettings,
    directLine,
    gid,
    iid,
    addLinks,
    availblityForm,
    servicePopup,
    inZenDesk,
    bookingApp,
    googleAnalytics
  ) =>
    () =>
      (next) =>
        (card) => {
          switch (card.attachment.contentType) {
            case "application/vnd.microsoft.card.hero":
              return (
                <CustomHeroCard
                  herocard={card.attachment.content}
                  replyToId={card.activity.replyToId}
                  iid={iid}
                  conversationId={card.activity.conversation.id}
                  messageId={card.activity.id}
                  addLinks={addLinks}
                  gid={gid}
                  api={api}
                  googleAnalytics={googleAnalytics}
                  directLine={directLine}
                  botSettings={botSettings}
                  availblityForm={availblityForm}
                  servicePopup={servicePopup}
                  cardActivitiesSummary={
                    card.activity !== undefined && card.activity.summary !== undefined
                      ? card.activity.summary
                      : ""
                  }
                  inZenDesk={inZenDesk}
                  bookingApp={bookingApp}
                />
              );
            case "ako/file-upload-prompt":
              return <FileUploadCard content={card.attachment.content} api={api} />;
            case "text/markdown":
              return (
                <CustomMessage
                  content={card.attachment.content}
                  iid={iid}
                  replyToId={card.activity.replyToId}
                  conversationId={card.activity.conversation.id}
                  messageId={card.activity.id}
                  cardActivitiesSummary={
                    card.activity !== undefined && card.activity.summary !== undefined
                      ? card.activity.summary
                      : ""
                  }
                  inZenDesk={inZenDesk}
                ></CustomMessage>
              );
            case "application/vnd.microsoft.card.video":
              return (
                <CustomVideoCard
                  card={card}
                  content={card.attachment.content}
                  iid={iid}
                  replyToId={card.activity.replyToId}
                  conversationId={card.activity.conversation.id}
                  messageId={card.activity.id}
                  cardActivitiesSummary={
                    card.activity !== undefined && card.activity.summary !== undefined
                      ? card.activity.summary
                      : ""
                  }
                  inZenDesk={inZenDesk}
                ></CustomVideoCard>
              );
            default:
              return next(card);
          }
        };